import { useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import { config } from './config.js';
import UserMenu from './components/UserMenu';
import ComingSoon from './components/ComingSoon';
import UserInfo from './components/UserInfo';
import InitUser from './components/InitUser';
import UserAdmin from './components/UserAdmin';
import CatalogImport from './components/CatalogImport';
import UserTags from './components/UserTags';
import SongLists from './components/SongLists';
import { User } from './classes/User';
// import { createBrowserHistory } from 'history';
import { bootUser } from './util';

// export const history = createBrowserHistory({ basename: process.env.PUBLIC_URL});

export default function App() {

  const [user, set_user] = useState({uuid:'', data:{display_name:''}});

  const doUserUpdate = (u) => {
    if (u instanceof User) {
      set_user(u);
    } else {
      let usr = new User(u);
      set_user(usr);
    }
  }

  if (user.uuid == null) {
    return(bootUser());
  }
  try {
    return(
      <BrowserRouter>
      <UserMenu user={user} updateUser={doUserUpdate} />
      {(user.data.new_user !== undefined && user.uuid !== '') &&
      <InitUser user={user} updateUser={doUserUpdate} />
      }
      {(user.data.new_user === undefined && user.uuid !== '') &&
      <Routes>
        <Route path="/app/users/info" element={<UserInfo user={user} updateUser={doUserUpdate}/>} />
        <Route path="/app/users/browse" element={<ComingSoon desc="Browse the site to find music, DJs, or MCs"/>} />
        <Route path="/app/dj/import" element={<CatalogImport />} />
        <Route path="/app/dj/tags" element={<UserTags user={user}/>} />
        <Route path="/app/dj/lists" element={<SongLists user={user}/>} />
        <Route path="/app/mc/parties" element={<ComingSoon desc="Select music and plan a party"/>} />
        <Route path="/app/mc/findDJ" element={<ComingSoon desc="Find a DJ for your party"/>} />
        <Route path="/app/partyhost/findMC" element={<ComingSoon desc="Find an MC to work with to help plan your party"/>} />
        <Route path="/app/admin/useradmin" element={<UserAdmin user={user} updateUser={doUserUpdate} />} />
        <Route path="/app" element={<ComingSoon desc="Browse the site to find music, DJs, or MCs"/>} />
      </Routes>
      }
      </BrowserRouter>
    )
  } catch (error) {
      return(bootUser());
  }
}

ReactDOM.render(<App /> , document.getElementById("root"))